import * as React from 'react';

import * as styles from './ChatPageLayout.css';

type TProps = {
  date: React.ReactNode;
  messages: React.ReactNode;
};

export const ChatPageLayout: React.FC<TProps> = ({ date, messages }) => {
  return (
    <div>
      <div className={styles['date']} data-name="ChatPageLayout_date">
        {date}
      </div>
      <div className={styles['messages']}>{messages}</div>
    </div>
  );
};
